import {
  getAuth,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
} from "firebase/auth";
import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import Field from "ui/components/Input/Field";
import { showError, showSuccess } from "infra/helpers/alerta";
import CardDefault from "ui/components/Cards/CardDefault";

const auth = getAuth();

function TrocarSenhaTab() {
  const [isLoading, setIsLoading] = useState(false);
  const { control, handleSubmit, watch, formState } = useForm<{
    senhaAtual: string;
    novaSenha: string;
    repetir: string;
  }>({
    mode: "all",
  });

  const form = watch();

  const reauthenticate = async (currentPassword: string) => {
    const user = auth.currentUser;
    if (user?.email) {
      const cred = EmailAuthProvider.credential(user.email, currentPassword);
      return reauthenticateWithCredential(user, cred);
    }
  };

  const onSubmit = async (data: {
    senhaAtual: string;
    novaSenha: string;
    repetir: string;
  }) => {
    if (data.novaSenha !== data.repetir) {
      return showError("As senhas devem ser iguais");
    }

    setIsLoading(true);

    try {
      const user = auth.currentUser!;

      await reauthenticate(data.senhaAtual).then(async () => {
          await updatePassword(user, data.novaSenha).catch(() =>
            showError("Houve um erro ao atualizar a senha, tente novamente.")
          );

          showSuccess("Senha atualizada com sucesso.");
        })
        .catch(() => showError("Senha atual incorreta."));
    } catch (e) {
      showError("Houve um erro ao atualizar a senha, tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CardDefault>
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <Text mb="16px" fontSize="18px">
          Trocar Senha
        </Text>

        <Box as={Row} gutter={32} mb={4}>
          <Box as={Col} xs={10} alignSelf="flex-end">
            <Field
              control={control}
              name="senhaAtual"
              label="Senha atual"
              inputProps={{
                type: "password",
              }}
              rules={{ required: "Campo obrigatório" }}
            />
          </Box>
        </Box>

        <Box as={Row} gutter={32} mb={4}>
          <Box as={Col} xs={10} alignSelf="flex-end">
            <Field
              control={control}
              name="novaSenha"
              label="Nova senha"
              inputProps={{
                type: "password",
              }}
              rules={{ required: "Campo obrigatório" }}
            />
          </Box>
        </Box>

        <Box as={Row} gutter={32} mb={4}>
          <Box as={Col} xs={10} alignSelf="flex-end">
            <Field
              control={control}
              name="repetir"
              label="Repetir a nova senha"
              inputProps={{
                type: "password",
              }}
              rules={{
                required: "Campo obrigatório",
                validate: (v) =>
                  v === form.novaSenha
                    ? undefined
                    : "As senhas devem ser iguais",
              }}
            />
          </Box>
        </Box>

        <Flex w="100%" justifyContent="flex-end" mt={16}>
          <PrimaryButton
            type="submit"
            isLoading={isLoading}
            disabled={!formState.isValid}
          >
            Salvar alterações
          </PrimaryButton>
        </Flex>
      </form>
    </CardDefault>
  );
}

export default TrocarSenhaTab;
